import React from 'react';
import './Code.css';

const Code = () => {
  return (
    <div className='code-container'>
        <img src='/images/man.png' alt='' className='man-image' />
      <div className="text-section">
        <h3>Expertise in software engineering blended with data science</h3>
        <h4>The real world is not just data science, We capture the complete picture.</h4>
      </div>
      <img src='/images/code.png' alt='Code example' className="code-image" />
    </div>
  );
};

export default Code;
